let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("fliVL"), load("gTmR2")]).then(() => parcelRequire('dVSum'));